export default {
	state: {
		projetoFirebase: {}
	},
	getters: {
		"projetoFirebase": state => state.projetoFirebase
	},
	mutations: {
		setProjetoFirebase(state, payload) {
			state.projetoFirebase = payload
		}
	},
	actions: {
		atualizarEstadoProjetoFirebase({ commit }, payload) {
			commit('setProjetoFirebase', payload)
		}
	}
};